<style>
@import url('https://fonts.googleapis.com/css2?family=Lato:wght@400;900&display=swap');

#app {
  font-family: 'Lato', Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: left;
  color: #2c3e50;
  margin-top: 0px;

}
.photo-description {
  font-style: italic;
  padding-right: 3em;
  padding-left: 3em;
  text-align: center;
}
.text-strong{
  font-weight: bold;
}
.mainphoto {
  width: 40%;
  max-height: 40%;
  margin: auto;
  display: block;
}
</style>

<template>
  <div id="app">
    <!-- <Panorama msg="Welcome to Your Vue.js App"/> -->
    <router-view />
  </div>
</template>

<script>
// import Panorama from "@/components/Panorama.vue";

export default {
  name: "App",
  components: {
    // Panorama
  }
};
</script>
